// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Image_first.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/inv_goa.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/Image_third.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/bg-image.jfif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/image_4.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top {
  position: fixed;
  bottom: 15%;
  right: 32px;
  background-color: transparent;
  /* Set your desired background color */
  border: 3px solid rgb(128, 176, 54) !important;
  color: rgb(128, 176, 54);
  /* Set your desired text color */
  border: none;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  padding: 15px;
  display: none;
  transition: background-color 0.3s;
  width: 50px;
  height: 50px;
  align-items: center;
  transition: background-color 0.3s;
  justify-content: center;
}

.scroll-to-top.visible {
  display: flex;
}

.mt-6 {
  margin-top: 3.5rem;
}

.fw-500 {
  font-weight: 500;
}

.footer-container a {
  font-family: Karla, Inter;
}
.footer-container a:hover {
  color: #b5cd53 !important;
}
.footer-container h6 {
  margin-bottom: 12px;
}
.footer-container p {
  margin-bottom: 4px;
}

.marquee-container {
  overflow: hidden;
}

.marquee-text {
  animation: scroll 15s linear infinite;
  cursor: pointer;
}

.marquee-container:hover .marquee-text {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateY(80%);
  }
  100% {
    transform: translateY(-80%);
  }
}
.social-container a {
  color: #3a7425;
}

.contactus-container a {
  color: unset;
}

.first_card,
.second_card,
.third_card,
.fourth_card {
  height: 420px;
}

.advertise-modal {
  margin: 0 auto;
  min-height: 100%;
}

.cursor-pointer {
  cursor: pointer;
}

.scroll-button {
  display: none;
  position: fixed;
  bottom: 100px;
  right: 20px;
  background-color: rgb(128, 176, 54);
  color: #fff;
  padding: 12px;
  cursor: pointer;
  font-size: 18px;
  border: none;
  outline: none;
  transition: background-color 0.3s;
}

.scroll-button.visible {
  display: block;
}

.scroll-button:hover {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.react-transform-wrapper,
.react-transform-component {
  width: 100% !important;
}

a {
  text-decoration: none;
}

.nav-parents {
  /* background-color: aquamarine; */
  backdrop-filter: blur(3px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-parents:hover {
  background-color: #fff;
}

.nav-parents:hover .profile {
  color: black;
}

.nav-parents:hover .text-sm {
  color: black;
}

.nav-parents:hover .nav_notification {
  color: black;
}

.dark-nav-header {
  background-color: #333e48;
}

.dark-nav-header .dropdown-menu {
  background-color: rgba(51, 62, 72, 0.95) !important;
  backdrop-filter: blur(3px);
  color: #f1f1f1;
}

.dark-nav-header a {
  color: #f1f1f1 !important;
  text-decoration: none;
}

.dark-nav-header.nav-parents:hover {
  background-color: #333e48;
}

.nav-parents:hover .dark-nav-header .text-sm {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.nav-parents:hover .dark-nav-header.profile {
  color: #ececec;
}

.nav-parents:hover .dark-nav-header.nav_notification {
  color: #ececec;
}

.dark-nav-header.nav_notification {
  background-color: rgba(255, 255, 255, 0.183);
}

.dropdown-menu a {
  color: black;
}

.sub-menu-links:hover {
  color: #b5cd53 !important;
}

.sub-menu-links {
  color: #e1e1e1;
}

.sub-menu-links-main:hover {
  color: #45842e;
}

.sub-menu-links.dark-nav-header:hover {
  color: aqua;
}

.nav_notification {
  padding: 18px 19px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ececec;
}

.navbar-nav .dropdown-menu {
  width: 100%;
  position: fixed !important;
  border-radius: 0px !important;
  padding: 0px;
  margin: -1px;
  backdrop-filter: blur(3px);
}

.dropdown-menu {
  background-color: rgba(255, 255, 255, 0.9215686275) !important;
  backdrop-filter: blur(3px);
}

.navbar-image {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  width: max-content;
  padding-right: 7%;
}

.nav-img2 {
  padding-right: 3%;
}

body {
  overflow-x: hidden;
}

.nav_home {
  position: relative;
  font-size: 16px;
}

.nav_home::after {
  content: "";
  position: absolute;
  inset: 35px 7px;
  width: 0px;
  height: 1.5px;
  background-color: rgb(35, 32, 32);
  border-radius: 2px;
  transition: width 0.2s linear;
}

.nav_home:hover::after {
  width: auto;
}

.dark-nav-header .nav_home:hover::after {
  width: auto;
  background-color: #ececec;
  border-radius: 2px;
  transition: width 0.2s linear;
}

.nav_plot:hover::after {
  width: 87px;
}

.nav_tenders:hover::after {
  width: 182px;
}

.nav_contact:hover::after {
  width: 85px;
}

.nav_help:hover::after {
  width: 35px;
}

.nav_eservice:hover::after {
  width: 94px;
}

.arrow_icon {
  position: relative;
  width: 15px;
  margin-left: 4px;
}

.upper-div:hover .arrow_bg {
  background-color: #fff !important;
}

.login-btn:hover .arrow_icon {
  transform: rotate(-45deg);
}

.login-btn {
  font-family: Karla, Inter, "Segoe UI", "Roboto";
  font-weight: 400;
  padding: 12px 36px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.1s ease-in-out;
  color: #000;
}

.btn.login-btn:hover {
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.4);
}

.nav_home h6 {
  font-size: 16px;
  font-family: Karla;
}

.image,
.image_frontface {
  /* background-size: cover; */
  background-repeat: no-repeat;
  animation-name: zoomout;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-direction: alternate;
  /* animation-iteration-count: 1; */
}

.image_frontface {
  position: absolute;
  inset: 0;
  background-color: rgba(42, 38, 38, 0.534);
}

@keyframes zoomout {
  0% {
    transform: scale(4);
  }
  100% {
    transform: scale(1.2);
  }
}
.index,
.texts {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0 120px 130px auto;
  z-index: 9;
  color: white;
  /* font-weight: bold; */
}

.index {
  bottom: 10%;
}

/* .texts_heading,
.texts_para {
    position: absolute;
    bottom: 15%;
    left: 10%;
    margin: 0 100px 130px auto;
    font-size: 60px;
    z-index: 999;
    color: white;
    font-style: italic;
    font-family: Inter;
    line-height: 60px;
} */
.texts_heading_image_2,
.texts_heading_image_1,
.texts_heading_image_3,
.texts_heading_image_4 {
  position: absolute;
  bottom: 15%;
  left: 5%;
  margin: 0 100px 130px auto;
  font-size: 20px;
  z-index: 999;
  color: white;
  font-family: Inter;
}

.texts_heading_image_2 .image_2_paragraph,
.texts_heading_image_1 .image_1_paragraph,
.texts_heading_image_3 .image_3_paragraph,
.texts_heading_image_4 .image_4_paragraph {
  position: absolute;
  left: 0%;
  width: 150%;
  margin: 0 100px 130px auto;
  font-size: 20px;
  z-index: 999;
  color: white;
  font-family: Inter;
}

.texts_heading_image_4 h1 {
  width: 70%;
}

.texts_para {
  font-family: Karla;
  bottom: 15%;
}

.texts_heading span {
  font-style: normal;
  font-weight: bold;
}

.texts_para {
  font-style: normal;
  right: 56%;
  margin: 0 100px 35px auto;
}

.index span {
  color: rgba(255, 255, 255, 0.393);
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.prev,
.next {
  position: absolute;
  bottom: 10%;
  right: 0;
  z-index: 1;
  background-color: rgb(33, 28, 28);
  text-align: center;
  background: 0 0;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
  margin: 0 110px 50px auto;
  backdrop-filter: blur(10px);
}

.carousel h1 {
  font-size: 60px;
}

.carousel .p {
  font-size: 18px;
}

.carousel {
  position: relative;
  margin-top: -110px;
}

.prev {
  margin-right: 190px;
}

.carousal-bg {
  width: 100%;
  height: 120vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg1 {
  width: 100%;
  height: 120vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg2 {
  width: 100%;
  height: 120vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg3 {
  width: 100%;
  height: 120vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg4 {
  width: 100%;
  height: 120vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.overlay {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(122, 126, 119, 0.6);
  z-index: 9999;
}

.overlay__inner {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.notification_count {
  padding: 0px 7px;
  margin: -11px auto auto 15px;
}

.overlay__content {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/portalComponents/commonStyles.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,sCAAA;EACA,8CAAA;EACA,wBAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAGI;EACI,yBAAA;AAAR;AAGI;EACI,yBAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,kBAAA;AAHR;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,qCAAA;EACA,eAAA;AAJJ;;AAOA;EACI,4BAAA;AAJJ;;AAOA;EACI;IACI,0BAAA;EAJN;EAOE;IACI,2BAAA;EALN;AACF;AASI;EACI,cAAA;AAPR;;AAYI;EACI,YAAA;AATR;;AAaA;;;;EAII,aAAA;AAVJ;;AAaA;EACI,cAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,eAAA;AAVJ;;AAaA;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,mCAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;AAVJ;;AAaA;EACI,cAAA;AAVJ;;AAaA;EACI,0CAAA;AAVJ;;AAaA;;EAEI,sBAAA;AAVJ;;AA6BA;EACI,qBAAA;AA1BJ;;AA6BA;EACI,kCAAA;EACA,0BAAA;EACA,iDAAA;AA1BJ;;AA6BA;EACI,sBAAA;AA1BJ;;AA6BA;EACI,YAAA;AA1BJ;;AA6BA;EACI,YAAA;AA1BJ;;AA6BA;EACI,YAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ;;AA6BA;EACI,mDAAA;EACA,0BAAA;EACA,cAAA;AA1BJ;;AA6BA;EACI,yBAAA;EACA,qBAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ;;AA6BA;EACI,eAAA;EACA,+BAAA;AA1BJ;;AA6BA;EACI,cAAA;AA1BJ;;AA6BA;EACI,cAAA;AA1BJ;;AA6BA;EACI,4CAAA;AA1BJ;;AA6BA;EACI,YAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ;;AA6BA;EACI,cAAA;AA1BJ;;AA6BA;EACI,cAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AA1BJ;;AA8BA;EACI,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;AA3BJ;;AA8BA;EACI,8DAAA;EACA,0BAAA;AA3BJ;;AA8BA;EACI,gDAAA;EACA,kBAAA;EACA,iBAAA;AA3BJ;;AA6BA;EACI,iBAAA;AA1BJ;;AA6BA;EACI,kBAAA;AA1BJ;;AA6BA;EACI,kBAAA;EACA,eAAA;AA1BJ;;AA6BA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,6BAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,YAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AA1BJ;;AA6BA;EACI,iCAAA;AA1BJ;;AA6BA;EACI,yBAAA;AA1BJ;;AA6BA;EACI,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uCAAA;EACA,WAAA;AA1BJ;;AA6BA;EACI,0CAAA;AA1BJ;;AA8BI;EACI,eAAA;EACA,kBAAA;AA3BR;;AA+BA;;EAEI,4BAAA;EACA,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iCAAA;EACA,6BAAA;EACA,8BAAA;EACA,kCAAA;AA5BJ;;AA+BA;EACI,kBAAA;EACA,QAAA;EACA,yCAAA;AA5BJ;;AA+BA;EACI;IACI,mBAAA;EA5BN;EA+BE;IACI,qBAAA;EA7BN;AACF;AAgCA;;EAEI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,0BAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;AA9BJ;;AAiCA;EACI,WAAA;AA9BJ;;AAiCA;;;;;;;;;;;;GAAA;AAcA;;;;EAII,kBAAA;EACA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA/BJ;;AAkCA;;;;EAII,kBAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA/BJ;;AAkCA;EACI,UAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,WAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,iBAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,UAAA;EACA,yBAAA;AA/BJ;;AAkCA;EACI,iCAAA;AA/BJ;;AAkCA;;EAEI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;AA/BJ;;AAkCA;;EAEI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;AA/BJ;;AAkCA;EACI,eAAA;AA/BJ;;AAkCA;EACI,eAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,kBAAA;AA/BJ;;AAkCA;EACI,mBAAA;AA/BJ;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA/BJ;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA/BJ;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA/BJ;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA/BJ;;AAkCA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA/BJ;;AAmCA;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;AAhCJ;;AAmCA;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAhCJ;;AAmCA;EACI,gBAAA;EACA,4BAAA;AAhCJ;;AAmCA;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;AAhCJ;;AAmCA;EACI;IACI,yBAAA;EAhCN;AACF","sourcesContent":[".scroll-to-top {\n    position: fixed;\n    bottom: 15%;\n    right: 32px;\n    background-color: transparent;\n    /* Set your desired background color */\n    border: 3px solid rgb(128, 176, 54) !important;\n    color: rgb(128, 176, 54);\n    /* Set your desired text color */\n    border: none;\n    border-radius: 50%;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 15px;\n    display: none;\n    transition: background-color 0.3s;\n    width: 50px;\n    height: 50px;\n    align-items: center;\n    transition: background-color 0.3s;\n    justify-content: center;\n}\n\n.scroll-to-top.visible {\n    display: flex;\n}\n\n.mt-6 {\n    margin-top: 3.5rem;\n}\n\n.fw-500 {\n    font-weight: 500;\n}\n\n.footer-container {\n    a {\n        font-family: Karla, Inter;\n    }\n\n    a:hover {\n        color: #b5cd53 !important;\n    }\n\n    h6 {\n        margin-bottom: 12px;\n    }\n\n    p {\n        margin-bottom: 4px;\n    }\n}\n\n.marquee-container {\n    overflow: hidden;\n}\n\n.marquee-text {\n    animation: scroll 15s linear infinite;\n    cursor: pointer;\n}\n\n.marquee-container:hover .marquee-text {\n    animation-play-state: paused;\n}\n\n@keyframes scroll {\n    0% {\n        transform: translateY(80%);\n    }\n\n    100% {\n        transform: translateY(-80%);\n    }\n}\n\n.social-container {\n    a {\n        color: #3a7425;\n    }\n}\n\n.contactus-container {\n    a {\n        color: unset;\n    }\n}\n\n.first_card,\n.second_card,\n.third_card,\n.fourth_card {\n    height: 420px;\n}\n\n.advertise-modal {\n    margin: 0 auto;\n    min-height: 100%;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.scroll-button {\n    display: none;\n    position: fixed;\n    bottom: 100px;\n    right: 20px;\n    background-color: rgb(128, 176, 54);\n    color: #fff;\n    padding: 12px;\n    cursor: pointer;\n    font-size: 18px;\n    border: none;\n    outline: none;\n    transition: background-color 0.3s;\n}\n\n.scroll-button.visible {\n    display: block;\n}\n\n.scroll-button:hover {\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.react-transform-wrapper,\n.react-transform-component {\n    width: 100% !important;\n}\n\n/////////////////////////////\n\n// .nav-parents::-webkit-scrollbar {\n//     width: 1px; /* Adjust the width of the scrollbar */\n//     height: 1px;\n// }\n\n// .nav-parents::-webkit-scrollbar-thumb {\n//     background-color: rgba(0, 0, 0, 0); /* Scrollbar color */\n//     border-radius: 1px; /* Rounded corners */\n// }\n\n// .nav-parents::-webkit-scrollbar-track {\n//     background-color: rgba(255, 255, 255, 0); /* Track color */\n// }\n\na {\n    text-decoration: none;\n}\n\n.nav-parents {\n    /* background-color: aquamarine; */\n    backdrop-filter: blur(3px);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.nav-parents:hover {\n    background-color: #fff;\n}\n\n.nav-parents:hover .profile {\n    color: black;\n}\n\n.nav-parents:hover .text-sm {\n    color: black;\n}\n\n.nav-parents:hover .nav_notification {\n    color: black;\n}\n\n.dark-nav-header {\n    background-color: #333e48;\n}\n\n.dark-nav-header .dropdown-menu {\n    background-color: rgba(51, 62, 72, 0.95) !important;\n    backdrop-filter: blur(3px);\n    color: #f1f1f1;\n}\n\n.dark-nav-header a {\n    color: #f1f1f1 !important;\n    text-decoration: none;\n}\n\n.dark-nav-header.nav-parents:hover {\n    background-color: #333e48;\n}\n\n.nav-parents:hover .dark-nav-header .text-sm {\n    font-size: 12px;\n    color: rgb(255 255 255 / 60%);\n}\n\n.nav-parents:hover .dark-nav-header.profile {\n    color: #ececec;\n}\n\n.nav-parents:hover .dark-nav-header.nav_notification {\n    color: #ececec;\n}\n\n.dark-nav-header.nav_notification {\n    background-color: rgba(255, 255, 255, 0.183);\n}\n\n.dropdown-menu a {\n    color: black;\n}\n\n.sub-menu-links:hover {\n    color: #b5cd53 !important;\n}\n\n.sub-menu-links {\n    color: #e1e1e1;\n}\n\n.sub-menu-links-main:hover {\n    color: #45842e;\n}\n\n.sub-menu-links.dark-nav-header:hover {\n    color: aqua;\n}\n\n.nav_notification {\n    padding: 18px 19px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.3);\n    color: #ececec;\n    // margin-right: 20px;\n}\n\n.navbar-nav .dropdown-menu {\n    width: 100%;\n    position: fixed !important;\n    border-radius: 0px !important;\n    padding: 0px;\n    margin: -1px;\n    backdrop-filter: blur(3px);\n}\n\n.dropdown-menu {\n    background-color: #ffffffeb !important;\n    backdrop-filter: blur(3px);\n}\n\n.navbar-image {\n    border-right: 1px solid rgba(255, 255, 255, 0.2);\n    width: max-content;\n    padding-right: 7%;\n}\n.nav-img2 {\n    padding-right: 3%;\n}\n\nbody {\n    overflow-x: hidden;\n}\n\n.nav_home {\n    position: relative;\n    font-size: 16px;\n}\n\n.nav_home::after {\n    content: '';\n    position: absolute;\n    inset: 35px 7px;\n    width: 0px;\n    height: 1.5px;\n    background-color: rgb(35, 32, 32);\n    border-radius: 2px;\n    transition: width 0.2s linear;\n}\n\n.nav_home:hover::after {\n    width: auto;\n}\n\n.dark-nav-header .nav_home:hover::after {\n    width: auto;\n    background-color: #ececec;\n    border-radius: 2px;\n    transition: width 0.2s linear;\n}\n\n.nav_plot:hover::after {\n    width: 87px;\n}\n\n.nav_tenders:hover::after {\n    width: 182px;\n}\n\n.nav_contact:hover::after {\n    width: 85px;\n}\n\n.nav_help:hover::after {\n    width: 35px;\n}\n\n.nav_eservice:hover::after {\n    width: 94px;\n}\n\n.arrow_icon {\n    position: relative;\n    width: 15px;\n    margin-left: 4px;\n}\n\n.upper-div:hover .arrow_bg {\n    background-color: #fff !important;\n}\n\n.login-btn:hover .arrow_icon {\n    transform: rotate(-45deg);\n}\n\n.login-btn {\n    font-family: Karla, Inter, 'Segoe UI', 'Roboto';\n    font-weight: 400;\n    padding: 12px 36px;\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n    transition: box-shadow 0.1s ease-in-out;\n    color: #000;\n}\n\n.btn.login-btn:hover {\n    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.4);\n}\n\n.nav_home {\n    h6 {\n        font-size: 16px;\n        font-family: Karla;\n    }\n}\n\n.image,\n.image_frontface {\n    /* background-size: cover; */\n    background-repeat: no-repeat;\n    animation-name: zoomout;\n    animation-duration: 4s;\n    animation-timing-function: linear;\n    animation-fill-mode: forwards;\n    animation-direction: alternate;\n    /* animation-iteration-count: 1; */\n}\n\n.image_frontface {\n    position: absolute;\n    inset: 0;\n    background-color: rgba(42, 38, 38, 0.534);\n}\n\n@keyframes zoomout {\n    0% {\n        transform: scale(4);\n    }\n\n    100% {\n        transform: scale(1.2);\n    }\n}\n\n.index,\n.texts {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    margin: 0 120px 130px auto;\n    z-index: 9;\n    color: white;\n    /* font-weight: bold; */\n}\n\n.index {\n    bottom: 10%;\n}\n\n/* .texts_heading,\n.texts_para {\n    position: absolute;\n    bottom: 15%;\n    left: 10%;\n    margin: 0 100px 130px auto;\n    font-size: 60px;\n    z-index: 999;\n    color: white;\n    font-style: italic;\n    font-family: Inter;\n    line-height: 60px;\n} */\n\n.texts_heading_image_2,\n.texts_heading_image_1,\n.texts_heading_image_3,\n.texts_heading_image_4 {\n    position: absolute;\n    bottom: 15%;\n    left: 5%;\n    margin: 0 100px 130px auto;\n    font-size: 20px;\n    z-index: 999;\n    color: white;\n    font-family: Inter;\n}\n\n.texts_heading_image_2 .image_2_paragraph,\n.texts_heading_image_1 .image_1_paragraph,\n.texts_heading_image_3 .image_3_paragraph,\n.texts_heading_image_4 .image_4_paragraph {\n    position: absolute;\n    left: 0%;\n    width: 150%;\n    margin: 0 100px 130px auto;\n    font-size: 20px;\n    z-index: 999;\n    color: white;\n    font-family: Inter;\n}\n\n.texts_heading_image_4 h1 {\n    width: 70%;\n}\n\n.texts_para {\n    font-family: Karla;\n    bottom: 15%;\n}\n\n.texts_heading span {\n    font-style: normal;\n    font-weight: bold;\n}\n\n.texts_para {\n    font-style: normal;\n    right: 56%;\n    margin: 0 100px 35px auto;\n}\n\n.index span {\n    color: rgba(255, 255, 255, 0.393);\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n    display: inline-block;\n    width: 25px;\n    height: 25px;\n    background-repeat: no-repeat;\n    background-position: 50%;\n    background-size: 100% 100%;\n}\n\n.prev,\n.next {\n    position: absolute;\n    bottom: 10%;\n    right: 0;\n    z-index: 1;\n    background-color: rgb(33, 28, 28);\n    text-align: center;\n    background: 0 0;\n    border: 0;\n    opacity: 0.5;\n    transition: opacity 0.15s ease;\n    margin: 0 110px 50px auto;\n    backdrop-filter: blur(10px);\n}\n\n.carousel h1 {\n    font-size: 60px;\n}\n\n.carousel .p {\n    font-size: 18px;\n}\n\n.carousel {\n    position: relative;\n    margin-top: -110px;\n}\n\n.prev {\n    margin-right: 190px;\n}\n\n.carousal-bg {\n    width: 100%;\n    height: 120vh;\n    background-image: url('../../assets/images/Image_first.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.bg1 {\n    width: 100%;\n    height: 120vh;\n    background-image: url('../../assets/images/inv_goa.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.bg2 {\n    width: 100%;\n    height: 120vh;\n    background-image: url('../../assets/images/Image_third.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.bg3 {\n    width: 100%;\n    height: 120vh;\n    background-image: url('../../assets/images/bg-image.jfif');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.bg4 {\n    width: 100%;\n    height: 120vh;\n    background-image: url('../../assets/images/image_4.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n// loading\n.overlay {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    background-color: rgba(122, 126, 119, 0.6);\n    z-index: 9999;\n}\n\n.overlay__inner {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.notification_count {\n    padding: 0px 7px;\n    margin: -11px auto auto 15px;\n}\n\n.overlay__content {\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
